<template lang="pug">
  sui-segment(vertical)
    sui-grid
      sui-grid-row
        sui-grid-column
          sui-menu(
            :widths="options.length")
            a(
              is="sui-menu-item",
              v-for="option in options",
              :key="option.key",
              :active="isActive(option.key)",
              :disabled="option.disabled",
              @click="select(option.key)") {{ option.name }}
</template>

<script>
export default {
  name: 'NavMenu',
  props: {
    options: {
      required: true,
    },
    value: {
      required: true,
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  methods: {
    select(key) {
      this.$emit('change', key);
    },
    isActive(key) {
      return this.value === key;
    },
  },
};
</script>
